import { QuantifyVisualisationType } from 'generated/graphql';

export const isTopSelectionSupported = (
  visualisationType?: QuantifyVisualisationType,
): boolean => {
  return (
    visualisationType === QuantifyVisualisationType.Bar ||
    visualisationType === QuantifyVisualisationType.Trend ||
    visualisationType === QuantifyVisualisationType.Pie
  );
};
